import { IconSuccess16, UIHeading5, UIText2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC, MouseEvent as ReactMouseEvent, useMemo } from 'react';

import { useCAForCard } from 'shared/hooks/useCAForCard';

import { Link } from '../InteractiveTypography';

import { prettyPluralizeAmenity } from './internal/utils';

import styles from './Amenities.css';

type Amenity = {
  id: number;
  label: string;
};

type AmenitiesProps = {
  amenities: Array<Amenity>;
  isShortListing: boolean;
  total: number;
  link: string;
  onMoreLinkClick?(e: ReactMouseEvent<HTMLAnchorElement>): void;
};

export const Amenities: FC<AmenitiesProps> = props => {
  const { amenities: amenitiesRaw, isShortListing, total, link, onMoreLinkClick } = props;

  const amenities = useMemo(
    () => (isShortListing ? amenitiesRaw.slice(0, 3) : amenitiesRaw),
    [isShortListing, amenitiesRaw],
  );

  const icon = (
    <div className={styles['amenity-icon-wrapper']}>
      <IconSuccess16 />
    </div>
  );

  const caForCard = useCAForCard();

  const trackMoreButtonClick = (): void =>
    caForCard({ action: 'click_sopr', category: 'Listing', label: 'to_card_other_conditions' });

  const amenitiesLen = amenities.length;
  /**
   * @description Разница между общим количеством удобств и присланным количеством (максимум присылают 5 штук)
   */
  const amenitiesLenDiff = total - amenitiesLen;
  const renderMoreButton = total > amenitiesLen;

  return (
    <div>
      <UIHeading5>Включено в стоимость</UIHeading5>
      <div className={clsx(styles['amenities'], isShortListing && styles['narrow'])}>
        {amenities.map(amenity => (
          <div className={styles['amenity']} key={amenity.id}>
            {icon}
            <UIText2>{amenity.label}</UIText2>
          </div>
        ))}
        {renderMoreButton && (
          <Link href={link} track={trackMoreButtonClick} onClick={onMoreLinkClick}>
            + {prettyPluralizeAmenity(amenitiesLenDiff)}
          </Link>
        )}
      </div>
    </div>
  );
};
